/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDataLocation = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.47 2.152a1 1 0 0 1 1.06 0l8 5A1 1 0 0 1 21 8v3.623a5.082 5.082 0 0 0-2-.6v-1.22l-6 3.75v5.642l.403-.252c.07.183.145.351.218.504.218.46.475.887.728 1.263l-1.819 1.137a1 1 0 0 1-1.06 0l-8-5A1 1 0 0 1 3 16V8a1 1 0 0 1 .47-.848zM5 9.804v5.642l6 3.75v-5.642zm7 2.017L18.113 8 12 4.18 5.887 8zm5 5.11C17 15.71 17.815 15 18.5 15s1.5.71 1.5 1.931c0 .177-.065.445-.233.798a6.699 6.699 0 0 1-.647 1.05c-.212.289-.43.553-.62.77-.19-.217-.408-.481-.62-.77a6.696 6.696 0 0 1-.647-1.05c-.168-.353-.233-.62-.233-.798zM18.5 13c-2.076 0-3.5 1.915-3.5 3.931 0 .596.196 1.173.427 1.657.236.496.543.968.84 1.374.59.803 1.207 1.428 1.355 1.573l.874.878.883-.876c.136-.135.758-.764 1.353-1.575.299-.406.605-.878.841-1.374.23-.484.427-1.06.427-1.657C22 14.915 20.576 13 18.5 13z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDataLocation as DataLocation };
